<template>
  <div class="clueDetails">
    <commonHeader title="线索详情">
      <template #buttons>
        <el-button
          plain
          v-if="detailsData.buttonVO && detailsData.buttonVO.isEditShow"
          v-show="!editFlag"
          @click="editHandle"
        >
          编辑
        </el-button>
        <el-button
          plain
          v-if="detailsData.buttonVO && detailsData.buttonVO.isReceiveShow"
          v-show="!editFlag"
          @click="collectHandle"
        >
          领取
        </el-button>
        <el-button
          plain
          v-if="detailsData.buttonVO && detailsData.buttonVO.isDistributeShow"
          v-show="!editFlag" @click="shareClueHandle"
        >
          分配
        </el-button>
        <el-button type="primary" v-show="editFlag" @click="saveHandle">保存</el-button>
        <el-button plain v-show="editFlag" @click="editClose">取消</el-button>
        <!-- <el-button @click="backOffHandle">返回</el-button> -->
      </template>
    </commonHeader>
    <div class="wrapper">
      <!-- 基础信息 -->
      <basicInformation
        ref="basicInformation"
        v-if="detailsData.lead && fieldPermission.lead_filed_lead_info && fieldPermission.lead_filed_lead_info.indexOf('查看') >= 0"
        :edit-permission="this.fieldPermission.lead_filed_lead_info.indexOf('编辑') >= 0"
        :details-data="detailsData"
      />
      <!-- 客户信息 -->
      <customerInformation
        ref="customerInformation"
        v-if="detailsData.lead && fieldPermission.lead_filed_customer_info && fieldPermission.lead_filed_customer_info.indexOf('查看') >=0"
        :edit-permission="fieldPermission.lead_filed_customer_info.indexOf('编辑') >= 0"
        :details-data="detailsData"
      />
      <!-- 活动信息 -->
      <activityInformation
        v-if="detailsData.marketActivity && fieldPermission.lead_filed_activity_info && fieldPermission.lead_filed_activity_info.indexOf('查看') >=0"
        :details-data="detailsData"
      />
      <!--<feedbackInformation v-if="detailsData.lead" />-->
      <!-- 历史记录 -->
      <historyRecord
        v-if="detailsData.lcOperationRecordList && detailsData.lcOperationRecordList.length > 0 && this.fieldPermission.lead_filed_operation_log && this.fieldPermission.lead_filed_operation_log.indexOf('查看') >=0"
        :details-data="detailsData"
      />
      <shareClueDialog
        :selected-pool-list="selectedPoolList"
        :share-clue-show="shareClueShow"
        @dialogCloseHandle="shareClueClose"
        @submitHandle="shareClueSubHandle"
      />
    </div>
  </div>
</template>

<script>
import commonHeader from '@/components/commonHeader';
import basicInformation from '../component/clueDetails/basicInformation';
import customerInformation from '../component/clueDetails/customerInformation';
import activityInformation from '../component/clueDetails/activityInformation';
// import feedbackInformation from '../component/clueDetails/feedbackInformation';
import historyRecord from '../component/clueDetails/historyRecord';
import shareClueDialog from '../component/cluePoolList/shareClueDialog';
import { clueDetailsApi, cluePoolListApi } from '../service';

export default {
  data () {
    return {
      detailsData: {},
      editFlag: false,
      fieldPermission: {},
      btnPermission: [],
      selectedPoolList: [],
      shareClueShow: false
    };
  },
  components: {
    commonHeader,
    basicInformation,
    customerInformation,
    activityInformation,
    // feedbackInformation,
    historyRecord,
    shareClueDialog
  },
  watch: {
    editFlag (val) {
      if (this.$refs.basicInformation) {
        this.$refs.basicInformation.editFlage = val;
      }
      if (this.$refs.customerInformation) {
        this.$refs.customerInformation.editFlage = val;
      }
    }
  },
  methods: {
    shareClueSubHandle (data) {
      this.$store.commit('setSubPageLoading', true);
      cluePoolListApi.distribute(data).then(res => {
        if (res.status === '200') {
          this.$message.success('操作成功');
          this.shareClueShow = false;
          this.$router.go(-1);
        }
        this.$store.commit('setSubPageLoading', false);
      });
    },
    shareClueClose () {
      this.shareClueShow = false;
    },
    shareClueHandle () {
      this.selectedPoolList = [this.detailsData.lead];
      this.shareClueShow = true;
    },
    backOffHandle () {
      this.$router.go(-1);
    },
    collectHandle () {
      this.$confirm('是否领取线索至个人私海？', '领取线索', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let params = [this.$route.query.leadId];
        cluePoolListApi.getClues(params).then(res => {
          if (res.status === '200') {
            this.$message.success('领取成功');
            this.$router.go(-1);
          }
        });
      }).catch(() => {

      });
    },
    async saveHandle () {
      let params = {};
      if (this.$refs.basicInformation) {
        params.lead = await this.$refs.basicInformation.getFormData();
      } else {
        params.lead = this.detailsData.lead;
      }
      if (this.$refs.customerInformation) {
        params.leadCustomer = await this.$refs.customerInformation.getFormData();
      } else {
        params.leadCustomer = this.detailsData.leadCustomer;
      }
      this.$store.commit('setSubPageLoading', true);
      clueDetailsApi.editLeadDetails(params).then(res => {
        if (res.status === '200') {
          this.$message.success('编辑成功');
          this.editFlag = false;
          this.detailsData = {};
          this.getDtailsData().then(res => {
            this.detailsData = res;
          });
        }
        this.$store.commit('setSubPageLoading', false);
      });
    },
    editClose () {
      this.editFlag = false;
      this.$refs.basicInformation.clearEditStatus();
      this.$refs.customerInformation.clearEditStatus();
    },
    editHandle () {
      this.editFlag = true;
    },
    getDtailsData () {
      return new Promise((resolve, reject) => {
        this.$store.commit('setSubPageLoading', true);
        clueDetailsApi.getDetailsData(this.$route.query.leadId).then(res => {
          if (res.status === '200') {
            resolve(res.data);
          }
          this.$store.commit('setSubPageLoading', false);
        });
      });
    },
    initPage () {
      this.getDtailsData().then(res => {
        this.detailsData = res;
        if (this.$route.query.editFlag) {
          this.$nextTick(() => {
            this.editFlag = true;
          });
        }
      });
    },
    btnShow (btnName, stateCode) {
      /* 待分配-1
        单位名称不准确-2
        线索可能重复-3
         */
      switch (btnName) {
        case '编辑':
          return this.btnPermission.indexOf('编辑') >= 0 && stateCode !== 12;
        case '领取':
          return this.btnPermission.indexOf('领取') >= 0 && (stateCode === 1 || stateCode === 2 || stateCode === 3);
        case '分配':
          return this.btnPermission.indexOf('分配') >= 0 && (stateCode === 1 || stateCode === 2 || stateCode === 3);
        default:
          return false;
      }
    }
  },
  mounted () {
    let jurisdiction = this.$store.state.userInfo.permissionDTO.leadModule;
    if (jurisdiction.lead_filed) {
      this.fieldPermission = jurisdiction.lead_filed;
    }
    if (jurisdiction.lead_function) {
      this.btnPermission = jurisdiction.lead_function.lead_function_lead_pool;
    }
    this.initPage();
  }
};
</script>

<style lang="scss" scoped>
  .clueDetails {
    > .wrapper > div {
      margin-bottom: 16px;
    }
  }
</style>
